import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';

import moment from 'moment';

//elements
import withLocalization from '../../../../../hoc/withLocalization.js';
import Input from '../../../../../elements/Input.js';
import Button from '../../../../../components/CustomButton/CustomButton.jsx';

const InternalTripleTexWidget = inject('clientStore', 'commonStore')(withLocalization(observer(class InternalTripleTexWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client_id: this.props.clientStore.currentEntity.client.id,
            emp_token: this.props.clientStore.currentEntity.client?.integration_details?.emp_token,
            session_expiry: moment(new Date()).add(28, 'days').format('YYYY-MM-DD'),
            packageName: this.props.clientStore.currentEntity.client?.integration_details?.integration_settings?.packageName || '',
            product: this.props?.payrollProduct,
            active: this.props.clientStore.currentEntity.client?.integration_details?.active
        };
    }
    handleChange = (name, value) => {
        this.setState({ [name]: value })
    }

    onValidate = async () => {
        const getPackageDetails = await this.props.clientStore.getTripleTexToken(this.state)
        this.setState({ packageName: getPackageDetails.packageName, active: true })
        if (getPackageDetails.isValidated) {
            this.props.commonStore.addNotification(this.props.t('Token verified successfully') + ', ' + this.props.t('Please complete the integration settings.'), null, 'success')
            if (this.props.handleSubTabChange) {
                await this.props.clientStore.load(this.state.client_id)
                await this.props.commonStore.setAppLoaded();
                this.props.handleSubTabChange('payroll_integrations_settings');
            }
        }
    }

    resetIntegration = async () => {
        const { product, emp_token, session_expiry } = this.state
        try {
            const str = `${this.props.t(`Do You want to Reset the integration with`)} ${product}`
            confirmAlert({
                title: `${this.props.t('Are You Sure')}`,
                message: str,
                buttons: [
                    {
                        label: this.props.t('Yes'),
                        onClick: async () => {
                            await this.props.clientStore.getTripleTexToken({ resetIntegration: true, product, emp_token, session_expiry }).then((res) => {
                                this.props.commonStore.addNotification(this.props.t('Integration Reset Successful'), null, 'success');
                                this.setState({ emp_token: "", product: "", active: false, packageName: "" })
                            })
                            await this.props.clientStore.load(this.state.client_id)
                        },
                    },
                    {
                        label: this.props.t('No')
                    },
                ],
            })

        }
        catch (err) {
            this.props.commonStore.addNotification(this.props.t(err || 'error'), null, 'error');
        }
    }

    render() {
        return (
            <>
                <Input
                    className={'mt-4'}
                    label={this.props.t('Employee Token')}
                    name="emp_token"
                    placeholder={this.props.t("Enter Employee Token")}
                    value={this.state.emp_token}
                    onChange={(event) => this.handleChange('emp_token', event.target.value)}
                    disabled={this.state.active}
                />
                <Input
                    className={'mt-4'}
                    label={this.props.t('TripleTex Plan')}
                    name="tripleTex_plan"
                    placeholder={this.props.t("TripleTex Plan")}
                    value={this.state.packageName}
                    disabled={true}
                />
                <div className='d-flex justify-content-between mt-4'>
                    <Button className="btn btn-fill" onClick={this.onValidate}>
                        {this.props.t('Validate Token')}
                    </Button>
                    <Button className="btn" onClick={this.resetIntegration}
                        title={this.props.t('It will Reset your connection with current Intgration')}>
                        {this.props.t('Reset Integration')}
                    </Button>
                </div>
            </>
        );
    }
})));

const TripleTexWidget = observer(class TripleTexWidget extends Component {
    render() {
        return <InternalTripleTexWidget {...this.props} mode="managers" />;
    }
});

export default TripleTexWidget;